var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "26", height: "26", viewBox: "0 0 26 26", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { id: "pass-Symbols", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        { id: "pass-Icon/Cancel/Line/32", transform: "translate(-3 -3)", fill: "#1A1A1A", fillRule: "nonzero" },
        React.createElement("path", { d: "M3.716 3.716a1.25 1.25 0 0 1 1.768 0L15.8 14.033 26.116 3.716a1.25 1.25 0 0 1 1.666-.091l.102.091a1.25 1.25 0 0 1 0 1.768L17.567 15.8l10.317 10.316a1.25 1.25 0 0 1 .091 1.666l-.091.102a1.25 1.25 0 0 1-1.768 0L15.8 17.567 5.484 27.884a1.25 1.25 0 0 1-1.666.091l-.102-.091a1.25 1.25 0 0 1 0-1.768L14.033 15.8 3.716 5.484a1.25 1.25 0 0 1-.091-1.666z", id: "pass-Combined-Shape" })
      )
    )
  );
});


// WEBPACK FOOTER //
// ./src/shared/components/svgs/pass.svg